import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=67dcc1d7&scoped=true"
import script from "./ButtonDelete.vue?vue&type=script&lang=js"
export * from "./ButtonDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcc1d7",
  null
  
)

export default component.exports